'use client'

import React from 'react'
import { blockComponents } from '@/blocks/components'

export type Block = {
  id?: string | null
  blockType: string
  blockName?: string | null
}

export const RenderBlocks: React.FC<{
  blocks: Block[]
}> = ({ blocks }) => {
  const hasBlocks = blocks && Array.isArray(blocks) && blocks.length > 0
  if (!hasBlocks) return null

  return (
    <>
      {blocks.map((block, index) => {
        const { blockType } = block

        if (blockType && blockType in blockComponents) {
          const Block = blockComponents[blockType]

          if (Block) {
            return <Block key={index} {...block} />
          }
        }
        return null
      })}
    </>
  )
}
